module.exports = __webpack_public_path__ + "static/img/award2.24b9eef.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award2.png
// module id = a3en
// module chunks = 7